import { render, staticRenderFns } from "./SvgBadge.vue?vue&type=template&id=661f90b6&scoped=true&"
import script from "./SvgBadge.vue?vue&type=script&lang=js&"
export * from "./SvgBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f90b6",
  null
  
)

export default component.exports